//TODO: нужен ли этот компонент??? (посмотреть ui-kit)
import { PropsWithChildren } from 'react';
import cn from 'classnames';
import styles from './outline-button.module.scss';

type OutlineButtonProps = PropsWithChildren & {
  className?: string;
  onClick?: () => void;
};

export const OutlineButton = ({ className, children, onClick }: OutlineButtonProps) => {
  return (
    <button onClick={onClick} className={cn(styles.button, className)}>
      {children}
    </button>
  );
};
